import { Formik } from 'formik'
import React, { useContext } from 'react'
import { match, Redirect } from 'react-router'
import * as Yup from 'yup'
import { isTokenValid } from '../../utils/auth'
import Logo from '../icons/ui/Logo'
import LoginForm from './LoginForm'
import { messageTypes, MessageTopBar } from '../ui/entity/MessageTopBar'

interface ILogin {
  error: string | null
  isFetching: boolean
  isLogged: boolean
  match: match<any>
  type: string
  userAuthorization: () => void
}

const Login = (props: ILogin) => {
  if (props.isLogged || isTokenValid()) {
    switch (props.type) {
      case 'driver':
        return <Redirect to={'/driver-landing'} />
      case 'rider':
        return <Redirect to={'/rider-landing'} />
    }
    return <Redirect to={`/scheduler`} />
  }

  return (
    <div className='bg-green flex items-center justify-center' style={{ minHeight: '100vh' }}>
      <div className='bg-white b-rad-10 my3 pb3 pt4 px3'>
        <Logo className='block b-rad-6 icon--90x90 margin-auto' />
        <Formik
          initialValues={{
            emailOrUsername: '',
            password: '',
            rememberMe: false
          }}
          validationSchema={Yup.object().shape({
            emailOrUsername: Yup.string().required('Username or email is required'),
            password: Yup.string().required('Password is required')
          })}
          onSubmit={props.userAuthorization}
          render={LoginForm}
        />
      </div>
    </div>
  )
}

export default Login



// WEBPACK FOOTER //
// ./src/components/authentication/Login.tsx